/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex } from '@radix-ui/themes';

import { use, useCallback } from 'fierry/react';

import Navigation from 'solis/navigation';
import Time from 'solis/time';

import * as Board from 'solis/react/board';
import Title from 'solis/react/element/title';
import Tile from 'solis/react/element/tile';
import Text from 'solis/react/primitive/text';

import BoardCass from 'solis/logic/board/cass';
import BoardRanges from 'solis/logic/board/ranges';
import BoardUser from 'solis/claude/logic/board/user';

import Args from 'solis/claude/action/args';
import TimeBadge from 'solis/claude/element/time.badge';
import PeakRow from 'solis/claude/element/peak/row';


const TILE_WIDTH = 340;
const TILE_HEIGHT = 150;

const NAMED_PLAYERS = 3;


const formatPlayers = (board) =>
{
  const names = new BoardRanges(board).getUsersByAttachDate().map(user => new BoardUser(board, user.cass.id).getName());

  const named = names.slice(0, NAMED_PLAYERS);
  const others = names.length - named.length;

  if (others > 0)
  {
    return named.join(', ') + ' and ' + others + ' others';
  }

  return named.length > 1 ? named.slice(0, -1).join(', ') + ' and ' + named.at(-1) : named.join('');
};


const formatMultiplier = (count) =>
{
  return '×' + Number(count.toFixed(1));
};


const OnClick = (event, dispatch, boardID) =>
{
  dispatch.replaceArgs({ [Args.DeployBoard]: boardID });
};


export default ({ board, selected }) =>
{
  const dispatch = use(Navigation.Dispatch);
  const now = use(Time);

  const onClick = useCallback(OnClick, [ dispatch, board.cass.id ]);

  return (
    <Tile selected = {selected} onClick = {onClick}>
      <Flex direction = 'column' gap = '3'>

        <Flex direction = 'column' gap = '1'>
          <Flex justify = 'between' align = 'center'>
            <Title>{board.cass.name}</Title>
            <TimeBadge date = {board.cass.destroyDate} />
          </Flex>
          <Text.Note>{formatPlayers(board)}</Text.Note>
        </Flex>

        <Board.WithBoard board = {board} width = {TILE_WIDTH} height = {TILE_HEIGHT} zoom = {0} settings = {Board.Preview} />

        <Flex justify = 'between' align = 'center'>
          <Text.Note>{'Authority '}<Text size = '1' weight = 'bold'>{formatMultiplier(new BoardCass(board).getRemainingScoreCount(now))}</Text></Text.Note>
          <PeakRow board = {board} />
        </Flex>

      </Flex>
    </Tile>
  );
};
